var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArtiklModalEdit',{ref:"artikleditComponent",attrs:{"isModal":false},on:{"artiklsaved":_vm.onsaved}})
}
var staticRenderFns = []

export { render, staticRenderFns }